import { useLocalizedValues } from "ui/hooks";
import { displayMessages } from "ui/screens/translation-managers/translation-managers.localization";

import { IPlexTranslationMessageRow } from "../PlexTranslationMessages.state";

export const useCurrentAssignee = (rows?: IPlexTranslationMessageRow[]) => {
  const localizedValues = useLocalizedValues(() => ({
    variousAssignee: displayMessages.property("variousAssignee")
  }));

  let assignee: string | undefined = undefined;

  if (rows && rows.length > 0) {
    const isEveryElemTheSame = rows && rows.every(val => val.data.assignedTo === rows[0].data.assignedTo);
    if (isEveryElemTheSame) {
      assignee = rows[0].data.assignedTo;
    } else {
      assignee = localizedValues.variousAssignee;
    }
  }

  return assignee;
};
